<template>
  <b-card no-body>
    <b-card-body>
      <b-row>
        <b-col cols="12" class="d-flex flex-wrap" style="gap: 8px">
          <div class="custom-field-range">
            <small class="text-nowrap">Registration Date</small>
            <flat-pickr
              :value="registerDate"
              id="registerDate"
              class="form-control"
              :config="config"
              placeholder="dd/mm/yyyy"
              @input="(val) => $emit('update:registerDate', val)"
            />
          </div>

          <div class="custom-field-range">
            <small class="text-nowrap">Last Logged In Date</small>
            <flat-pickr
              :value="lastLoggedDate"
              id="lastLoggedDate"
              class="form-control"
              :config="config"
              placeholder="dd/mm/yyyy"
              @input="(val) => $emit('update:lastLoggedDate', val)"
            />
          </div>

          <div class="custom-field-select">
            <label>BDM</label>
            <v-select
              :value="bdmOrder.label"
              :options="bdmOptions"
              :clearable="false"
              @input="(val) => $emit('update:bdmOrder', val)"
            />
          </div>

          <div class="custom-field-select">
            <label>Tags</label>
            <v-select
              :value="tagOrder.label"
              :options="tagOptions"
              :clearable="false"
              class="w-100"
              @input="(val) => $emit('update:tagOrder', val)"
            />
          </div>
          <div class="custom-field-select">
            <label>Profile</label>
            <v-select
              :value="profileOrder.label"
              :options="profileOptions"
              :clearable="false"
              class="w-100"
              @input="(val) => $emit('update:profileOrder', val)"
            />
          </div>
          <div class="custom-field-select">
            <label>Status</label>
            <v-select
              :value="statusOrder.label"
              :options="statusOptions"
              :clearable="false"
              class="w-100"
              @input="(val) => $emit('update:statusOrder', val)"
            />
          </div>

          <div class="d-flex align-items-end">
            <b-button
              size="sm"
              variant="primary"
              class="d-flex align-items-center justify-content-center text-nowrap"
              @click="$emit('filter')"
            >
              <feather-icon size="20" icon="FilterIcon" />
              Apply filters
            </b-button>
          </div>
          <div class="d-flex align-items-end">
            <b-button
              size="sm"
              variant="light"
              class="d-flex align-items-center justify-content-center text-nowrap"
              @click="$emit('clear')"
            >
              <feather-icon size="20" icon="XIcon" />
              Clear filter
            </b-button>
          </div>
        </b-col>
        <b-col class="d-flex justify-content-end mt-1" style="gap: 10px">
          <div class="d-flex align-items-end">
            <b-button
              ref="export"
              variant="outline-secondary"
              @click="handleShowModalExport"
            >
              <feather-icon size="12" icon="DownloadIcon" />
              Export
            </b-button>
          </div>
          <div class="d-flex align-items-end">
            <b-link :to="{ name: 'customers-create-account' }">
              <b-button size="sm" variant="primary" style="height: 35.59px">
                <span class="ml-25 align-middle">Create account</span>
              </b-button>
            </b-link>
          </div>
        </b-col>
      </b-row>
    </b-card-body>

    <!-- MODAL CONFIRM -->
    <b-modal
      ref="modal"
      :title="modal.title"
      centered
      cancel-variant="outline-secondary"
      hide-footer
    >
      <b-card-text style="color: black">
        {{ modal.content }}
      </b-card-text>
      <div class="d-flex justify-content-end align-items-center">
        <b-button
          ref="export"
          variant="outline-secondary"
          @click="$refs.modal.hide()"
          class="mr-1 mt-2"
          style="height: 38px;"
        >
          Close
        </b-button>
        <download-csv
          ref="csvDownloader"
          :data="exportData"
          name="customer-list.csv"
          class="mt-2"
        >
          <b-button ref="export" variant="primary" @click="() => {$refs.modal.hide()}">
            <feather-icon size="12" icon="DownloadIcon" />
            Export
          </b-button>
        </download-csv>
      </div>
    </b-modal>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BButton,
  BLink,
  BFormGroup,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { arrayProp, objectProp, stringProp } from "@/helpers/props";
import flatPickr from "vue-flatpickr-component";
import Spinner from "@core/components/Spinner";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    BButton,
    BLink,
    BFormGroup,
    flatPickr,
    ValidationProvider,
    ValidationObserver,
    Spinner,
  },
  props: {
    registerDate: stringProp(),
    lastLoggedDate: stringProp(),
    bdmOrder: objectProp(),
    tagOrder: objectProp(),
    profileOrder: objectProp(),
    statusOrder: objectProp(),

    bdmOptions: arrayProp(),
    tagOptions: arrayProp(),
    profileOptions: arrayProp(),
    statusOptions: arrayProp(),

    roleFilter: stringProp(),
    exportData: arrayProp(),
  },
  data() {
    return {
      config: {
        mode: "range",
        altFormat: "d-m-Y",
        altInput: true,
      },
      modal: {
        title: "",
        content: "",
      },
    };
  },

  methods: {
    setModal(title, content) {
      this.modal.title = title;
      this.modal.content = content;
    },

    showModal(type, item) {
      this.action = { item, type };
      if (type === "export") {
        this.setModal(
          "Export Customer List",
          "Are you sure you want to export the customer list?"
        );
      }
      this.$refs.modal.show();
    },
    handleShowModalExport() {
      this.$emit("export");
      this.showModal("export");
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
.custom-field {
  width: 100%;
  &-range {
    min-width: 215px;
    max-width: fit-content;
  }
  &-select {
    min-width: 150px;
    max-width: fit-content;
  }
}
</style>
